import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../../../shared/themes/redesignTokens";

interface SettingsCardProps {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  animationDelay?: string;
  children: React.ReactNode;
}

const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  subtitle,
  action,
  animationDelay = "0.15s",
  children,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: dt.cardBg,
        borderRadius: dt.radius,
        border: `1px solid ${dt.cardBorder}`,
        boxShadow: dt.cardShadow,
        padding: { xs: "16px", md: "24px" },
        animation: `fadeUp 0.5s cubic-bezier(0.4, 0, 0.2, 1) ${animationDelay} both`,
      }}
    >
      {(title || action) && (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1,
            mb: subtitle ? 0.5 : 2,
          }}
        >
          {title && (
            <Box
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                color: dt.textPrimary,
                fontFamily: dt.font,
              }}
            >
              {title}
            </Box>
          )}
          {action}
        </Box>
      )}
      {subtitle && (
        <Box
          sx={{
            fontSize: "13px",
            fontWeight: 400,
            color: dt.textSecondary,
            fontFamily: dt.font,
            mb: 2.5,
            lineHeight: 1.5,
          }}
        >
          {subtitle}
        </Box>
      )}
      {children}
    </Box>
  );
};

export default SettingsCard;
